var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCheckboxEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 18H3L2.29 17.71L0.29 15.71L0 15V3L0.29 2.29L2.29 0.29L3 0H15L15.71 0.29L17.71 2.29L18 3V15L17.71 15.71L15.71 17.71L15 18ZM3.41 16H14.59L16 14.59V3.41L14.59 2H3.41L2 3.41V14.59L3.41 16Z",
    fill: "#EAC31F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheckboxEmpty);
export default __webpack_public_path__ + "static/1765983986/media/icon-checkbox-empty.d0cb94510e067571d92f2d9d275c4e68.svg";
export { ForwardRef as ReactComponent };